import {Subscription} from 'rxjs';

import IPlayer from '../../../Player/Interfaces/IPlayer';

import createConsumerMediaStream from './Streams/createConsumerMediaStream';
import subscribeToConsumerMedia   from './Subscribers/subscribeToConsumerMedia';

const connectMediaSubscriptions = (
    player: IPlayer
): Subscription[] => ([
    subscribeToConsumerMedia(createConsumerMediaStream(player.consumerInput.media$), player.state.stores.media)
]);

export default connectMediaSubscriptions;